const
 SHOW_MODIFIER = 'grid-item__panel--show',
 BLUR_MODIFIER = 'grid-item__image--blur',
 GRID_ITEM_HIDDEN = 'grid-item--hidden',
 GRID_ITEM_PANEL = 'grid-item__panel',
 GRID_ITEM_IMAGE = 'grid-item__image';


class GridItem {
    constructor($gridItem, grid) {
      this.$gridItem = $gridItem;
      this.$panel = $gridItem.querySelector(`.${GRID_ITEM_PANEL}`);
      this.$image = $gridItem.querySelector(`.${GRID_ITEM_IMAGE}`);
      this.grid = grid;
      this.hidden = false;
      this.scalingDown = false;
      this.width = 0;
      this.height = 0;
      this.addEventListeners();
    }

    resize(width, height) {
      this.width = width;
      this.height = height;
      this.$gridItem.style.width = `${width}px`;
      this.$gridItem.style.height = `${height}px`;
    }
  
    setPosition(x, y) {
      this.$gridItem.style.top = `${y}px`;
      this.$gridItem.style.left = `${x}px`;
    }

    moveToAnimation(x, y) {
      this.$gridItem.style.transform = `translate(${x}px,${y}px)`;
    }
  
    isVisible() {
      return !this.hidden;
    }
  
    height() {
      return this.height;
    }

    width() {
      return this.width;
    }
  
    addEventListeners() {
      this.$gridItem.addEventListener('mouseover', this.showOverlay.bind(this));
      this.$gridItem.addEventListener('mouseout', this.hideOverlay.bind(this));
      this.$gridItem.addEventListener('transitionend', this.endGridAnimation.bind(this));
    }

    endGridAnimation() {
      if (this.scalingDown) {
        // When item has to dissapear
        this.hide();
      }
    }

    hide() {
      this.$gridItem.classList.add(GRID_ITEM_HIDDEN);
      this.$gridItem.style.transform = '';
      this.hidden = true;
      this.scalingDown = false;
    }

    scaleDown() {
      if (!this.isVisible()) {
        return;
      }
      this.$gridItem.style.transform = 'scale(.01)';
      this.scalingDown = true;
    }

    show() {
      this.$gridItem.classList.remove(GRID_ITEM_HIDDEN);
      this.$gridItem.style.transform = 'scale(1)';
      this.hidden = false;
    }
  
    showOverlay() {
      if (this.$panel.classList.contains(SHOW_MODIFIER)) {
        return;
      }
      this.$image.classList.add(BLUR_MODIFIER);
      this.$panel.classList.add(SHOW_MODIFIER);
    }
  
    hideOverlay() {
      if (!this.$panel.classList.contains(SHOW_MODIFIER)) {
        return;
      }
      this.$image.classList.remove(BLUR_MODIFIER);
      this.$panel.classList.remove(SHOW_MODIFIER);
    }

    reset() {
      this.$gridItem.style.transform = '';
    }
  }

  export default GridItem;